import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "phone-number-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "phone-number-loaded bsp-page__content"
}
const _hoisted_3 = { class: "message-templates-and-creation" }
const _hoisted_4 = { class: "message-templates bsp-section" }
const _hoisted_5 = { class: "phone-number" }
const _hoisted_6 = { class: "message-template-container" }
const _hoisted_7 = { class: "bsp-section-heading" }
const _hoisted_8 = {
  key: 0,
  class: "message-template-list"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "message-template-name" }
const _hoisted_11 = { class: "message-template-status" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "message-template-actions" }
const _hoisted_14 = {
  key: 0,
  class: "bsp-template-test",
  "aria-labelledby": "template-test-title"
}
const _hoisted_15 = { class: "bsp-template-test__heading" }
const _hoisted_16 = { class: "bsp-template-test__workspace" }
const _hoisted_17 = { class: "bsp-template-preview-panel" }
const _hoisted_18 = { class: "bsp-template-panel-heading" }
const _hoisted_19 = { class: "bsp-whatsapp-preview" }
const _hoisted_20 = { class: "bsp-whatsapp-preview__brand" }
const _hoisted_21 = { class: "bsp-whatsapp-preview__bubble" }
const _hoisted_22 = {
  key: 0,
  class: "bsp-template-preview__header"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "bsp-template-media-placeholder" }
const _hoisted_25 = {
  key: 1,
  class: "bsp-template-media-placeholder"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  key: 1,
  class: "bsp-template-preview__body"
}
const _hoisted_28 = {
  key: 2,
  class: "bsp-template-preview__footer"
}
const _hoisted_29 = {
  key: 3,
  class: "bsp-template-preview__button"
}
const _hoisted_30 = { class: "bsp-template-variables-panel" }
const _hoisted_31 = { class: "bsp-template-panel-heading" }
const _hoisted_32 = {
  key: 0,
  class: "bsp-template-no-variables"
}
const _hoisted_33 = {
  key: 0,
  class: "bsp-template-variable-group"
}
const _hoisted_34 = {
  key: 1,
  class: "bsp-template-variable-stack"
}
const _hoisted_35 = {
  key: 2,
  class: "bsp-template-variable-stack"
}
const _hoisted_36 = {
  key: 3,
  class: "bsp-template-variable-stack"
}
const _hoisted_37 = {
  key: 4,
  class: "bsp-template-location-grid"
}
const _hoisted_38 = {
  key: 1,
  class: "bsp-template-variable-group"
}
const _hoisted_39 = {
  key: 2,
  class: "bsp-template-variable-group"
}
const _hoisted_40 = { class: "bsp-template-recipient" }
const _hoisted_41 = {
  class: "bsp-template-recipient__icon",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "message-template-creator bsp-section" }
const _hoisted_43 = { class: "message-template-creation-form" }
const _hoisted_44 = { class: "message-template-components" }
const _hoisted_45 = {
  key: 0,
  class: "message-template-component-header"
}
const _hoisted_46 = { class: "bsp-template-component-heading" }
const _hoisted_47 = { class: "bsp-template-component-heading__copy" }
const _hoisted_48 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_49 = {
  key: 1,
  class: "bsp-template-parameter-list"
}
const _hoisted_50 = {
  key: 3,
  class: "bsp-template-component-note"
}
const _hoisted_51 = {
  key: 1,
  class: "message-template-component-body"
}
const _hoisted_52 = { class: "bsp-template-component-heading" }
const _hoisted_53 = { class: "bsp-template-component-heading__copy" }
const _hoisted_54 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_55 = {
  key: 0,
  class: "bsp-template-parameter-list"
}
const _hoisted_56 = {
  key: 2,
  class: "message-template-component-button"
}
const _hoisted_57 = { class: "bsp-template-component-heading" }
const _hoisted_58 = { class: "bsp-template-component-heading__copy" }
const _hoisted_59 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_60 = {
  key: 0,
  class: "bsp-template-button-list"
}
const _hoisted_61 = { class: "bsp-template-button-editor__heading" }
const _hoisted_62 = {
  key: 1,
  class: "bsp-template-component-note"
}
const _hoisted_63 = { class: "bsp-component-actions bsp-component-actions--buttons" }
const _hoisted_64 = {
  key: 3,
  class: "message-template-component-footer"
}
const _hoisted_65 = { class: "bsp-template-component-heading" }
const _hoisted_66 = { class: "bsp-template-component-heading__copy" }
const _hoisted_67 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_68 = { class: "bsp-template-component-picker" }
const _hoisted_69 = { class: "bsp-component-actions" }
const _hoisted_70 = {
  key: 4,
  class: "bsp-template-components-complete"
}

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref, computed } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import {
  MessageTemplate,
  PhoneNumber,
  WhatsappTemplate,
  CreateableTemplateComponent,
  CreateableHeaderComponent,
  CreateableBodyComponent,
  CreateableFooterComponent,
  CreateableButtonsComponent,
  ButtonTypeURL,
  HeaderComponent,
  WhatsappHeaderComponent,
  isWhatsappHeaderComponent,
  TextHeaderParameter,
  isLocationHeaderParameter,
  isVideoHeaderParameter,
  isDocumentHeaderParameter,
  isImageHeaderParameter,
  isTextHeaderParameter
} from '../services/AccountService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AEmptyViewCard, AIcon, AInput, ASelector, ATag } from '@adereso-ai/vue-components'
import { normalizeSearchTerm } from '@/utils/search'


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageTemplatesView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const phoneNumber = ref<PhoneNumber | undefined>(undefined)

const testPhoneNumber = ref('')
const messageTemplateName = ref('')
const messageTemplateLanguage = ref('')
const messageTemplateCategory = ref('')

const languageOptions = [
  { title: 'Spanish', value: 'es' },
  { title: 'English', value: 'en' },
  { title: 'French', value: 'fr' }
]

const categoryOptions = [
  { title: 'Authentication', value: 'AUTHENTICATION' },
  { title: 'Marketing', value: 'MARKETING' },
  { title: 'Utility', value: 'UTILITY' }
]

const headerFormatOptions = [
  { title: 'Text', value: 'TEXT' },
  { title: 'Image', value: 'IMAGE' },
  { title: 'Video', value: 'VIDEO' },
  { title: 'Document', value: 'DOCUMENT' },
  { title: 'Location', value: 'LOCATION' }
]

const messageTemplates = ref<Array<MessageTemplate>>([])
const templateSearch = ref('')

const testingMessageTemplate = ref<WhatsappTemplate | undefined>(undefined)

const headerComponent = ref<CreateableHeaderComponent | undefined>(undefined)

const bodyComponent = ref<CreateableBodyComponent | undefined>(undefined)

const footerComponent = ref<CreateableFooterComponent | undefined>(undefined)

const buttonsComponent = ref<CreateableButtonsComponent | undefined>(undefined)

const templateBreadcrumbs = computed(() => [
  { title: 'Accounts', to: { name: 'whatsapp-business-accounts' } },
  {
    title: 'Phone number',
    to: {
      name: 'phone-number',
      params: { wabaId: String(route.params.wabaId), phoneNumberId: String(route.params.phoneNumberId) }
    }
  },
  { title: 'Templates', disabled: true }
])

const filteredMessageTemplates = computed(() => {
  const query = normalizeSearchTerm(templateSearch.value)
  if (!query) return messageTemplates.value

  return messageTemplates.value.filter((messageTemplate) =>
    [messageTemplate.name, messageTemplate.language, messageTemplate.status]
      .some((value) => String(value || '').toLowerCase().includes(query))
  )
})

const testTemplateParameterCount = computed(() => {
  return testingMessageTemplate.value?.components.reduce((total, component) => {
    return total + (component.parameters?.length || 0)
  }, 0) || 0
})

const existingComponents = computed(() => {
  const components: CreateableTemplateComponent[] = []

  if (headerComponent.value !== undefined) {
    components.push(headerComponent.value)
  }
  if (bodyComponent.value !== undefined) {
    components.push(bodyComponent.value)
  }
  if (footerComponent.value !== undefined) {
    components.push(footerComponent.value)
  }
  if (buttonsComponent.value !== undefined) {
    components.push(buttonsComponent.value)
  }

  return components
})

function numberOfParameters (text: string) {
  const regex = /\{\{(\d+)\}\}/g
  const matches = text.match(regex)
  const numberOfParameters = matches ? matches.length : 0
  return numberOfParameters
}

function onUrlButtonUrlInput (button: ButtonTypeURL) {
  const numberOfParams = numberOfParameters(button.url)
  if (numberOfParams) {
    button.example = []
    for (let i = 0; i < numberOfParams; i++) {
      button.example.push('')
    }
  } else {
    button.example = null
  }
}

function onBodyTextInput (bodyComponent: CreateableBodyComponent) {
  const numberOfParams = numberOfParameters(bodyComponent.text)
  if (numberOfParams) {
    bodyComponent.example = { body_text: [[]] }
    for (let i = 0; i < numberOfParams; i++) {
      bodyComponent.example.body_text[0].push('')
    }
  } else {
    bodyComponent.example = null
  }
}

function onHeaderTextInput (headerComponent: CreateableHeaderComponent) {
  if (headerComponent.text) {
    const numberOfParams = numberOfParameters(headerComponent.text)
    if (numberOfParams) {
      headerComponent.example = { header_text: [] }
      for (let i = 0; i < numberOfParams; i++) {
        headerComponent.example.header_text.push('')
      }
    } else {
      headerComponent.example = null
    }
  }
}

function selectTestTemplate (messageTemplate: MessageTemplate) {
  testingMessageTemplate.value = {
    name: messageTemplate.name,
    language: { code: messageTemplate.language },
    components: []
  }

  let buttonCounter = 0
  let numberOfParams = 0
  let parameters = []

  for (const component of messageTemplate.components) {
    switch (component.type) {
      case 'HEADER': {
        const header = component as HeaderComponent
        const testHeader = {
          type: 'header',
          text: header.text,
          format: header.format,
          parameters: []
        } as WhatsappHeaderComponent
        const headerParameters: any[] = []
        switch (header.format) {
          case 'TEXT':
            numberOfParams = numberOfParameters(header.text)
            for (let i = 0; i < numberOfParams; i++) {
              headerParameters.push({ type: 'text', text: '', id: i })
            }
            break
          case 'IMAGE':
            headerParameters.push({
              type: 'image',
              image: {
                link: header.example?.header_handle[0] || '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'VIDEO':
            headerParameters.push({
              type: 'video',
              video: {
                link: header.example?.header_handle[0] || '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'DOCUMENT':
            headerParameters.push({
              type: 'document',
              document: {
                link: header.example?.header_handle[0] || '',
                filename: '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'LOCATION':
            headerParameters.push({
              type: 'location',
              location: {
                latitude: '',
                longitude: '',
                name: '',
                address: ''
              }
            })
            break
        }
        testHeader.parameters = headerParameters
        testingMessageTemplate.value.components.push(testHeader)
        break
      }
      case 'BODY':
        numberOfParams = numberOfParameters(component.text)
        parameters = []
        for (let i = 0; i < numberOfParams; i++) {
          parameters.push({ type: 'text', text: '', id: i })
        }
        testingMessageTemplate.value.components.push({
          type: component.type.toLowerCase(),
          text: component.text,
          parameters
        })
        break
      case 'FOOTER':
        testingMessageTemplate.value.components.push({
          type: 'footer',
          text: component.text
        })
        break
      case 'BUTTONS':
        for (const button of component.buttons) {
          switch (button.type) {
            case 'QUICK_REPLY':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'quick_reply',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [{ type: 'payload', payload: button.text }]
              })
              break
            case 'PHONE_NUMBER':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'phone_number',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [{ type: 'phone_number', text: button.text }]
              })
              break
            case 'URL':
              numberOfParams = 0
              numberOfParams = numberOfParameters(button.url)
              parameters = []
              for (let i = 0; i < numberOfParams; i++) {
                parameters.push({ type: 'text', text: '', index: i })
              }
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'url',
                url: button.url,
                index: buttonCounter.toString(),
                parameters
              })
              break
            case 'COPY_CODE':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'copy_code',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [
                  {
                    type: 'coupon_code',
                    coupon_code: button.example[0]
                  }
                ]
              })
              break
          }
          buttonCounter++
        }
        break
    }
  }
}

const failedToLoadImage = ref(false)

function addBodyComponent () {
  bodyComponent.value = { type: 'BODY', text: '' }
}

function addHeaderComponent () {
  headerComponent.value = { type: 'HEADER', text: '', format: 'TEXT' }
}

function addFooterComponent () {
  footerComponent.value = { type: 'FOOTER', text: '' }
}

function addButtonsComponent () {
  buttonsComponent.value = { type: 'BUTTONS', buttons: [] }
}

function removeHeaderComponent () {
  headerComponent.value = undefined
}

function removeBodyComponent () {
  bodyComponent.value = undefined
}

function removeFooterComponent () {
  footerComponent.value = undefined
}

function removeButtonsComponent () {
  buttonsComponent.value = undefined
}

function removeTemplateButton (buttonIndex: number) {
  buttonsComponent.value?.buttons.splice(buttonIndex, 1)
}

function buttonTypeLabel (buttonType: string) {
  const labels: Record<string, string> = {
    QUICK_REPLY: 'Quick reply',
    PHONE_NUMBER: 'Phone number',
    URL: 'Link',
    COPY_CODE: 'Copy code'
  }
  return labels[buttonType] || buttonType
}

function addQuickReplyButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ text: '', type: 'QUICK_REPLY' })
}

function addPhoneNumberButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ phone_number: '', text: '', type: 'PHONE_NUMBER' })
}

function addUrlrButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ url: '', text: '', example: [], type: 'URL' })
}

function addCopyCodeButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ example: [''], type: 'COPY_CODE', text: 'Copy offer code' })
}

function validTemplate () {
  return messageTemplateName.value !== '' && messageTemplateLanguage.value !== '' && existingComponents.value.length > 0 && bodyComponent.value !== undefined
}

async function createMessageTemplate () {
  loading.value = true
  if (messageTemplateName.value === '' || messageTemplateLanguage.value === '' || existingComponents.value.length === 0) {
    toastError('All fields are required')
    loading.value = false
    return
  }
  const accountService = await AccountService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  const messageTemplateCreation = {
    name: messageTemplateName.value,
    language: messageTemplateLanguage.value,
    category: messageTemplateCategory.value,
    components: existingComponents.value
  }

  try {
    await accountService.createMessageTemplate(wabaId, phoneNumberId, messageTemplateCreation)
    toastSuccess('Message template created')
    await getMessageTemplates(wabaId, phoneNumberId)
  } catch (error) {
    toastError('Error creating message template: ' + error)
  }
  loading.value = false
}

async function deleteMessageTemplate (messageTemplate: MessageTemplate) {
  loading.value = true
  const metaService = await MetaService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  try {
    await metaService.deleteMessageTemplate(wabaId, phoneNumberId, messageTemplate.id, messageTemplate.name)
    toastSuccess('Message template deleted')
    await getMessageTemplates(wabaId, phoneNumberId)
  } catch (error) {
    toastError('Error deleting message template:' + error)
  }
  loading.value = false
}

async function testMessageTemplate () {
  loading.value = true
  if (testingMessageTemplate.value === undefined) {
    toastError('Message template is needed to send template')
    loading.value = false
    return
  }
  if (testPhoneNumber.value === '') {
    toastError('Test phone number is needed to send template')
    loading.value = false
    return
  }
  const metaService = await MetaService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  const components = testingMessageTemplate.value.components.filter((component) => {
    return component.type !== 'footer' &&
      (component.type !== 'button' ||
      (component.sub_type !== 'phone_number'))
  })
  testingMessageTemplate.value.components = components

  try {
    const response = await metaService.testMessageTemplate(
      wabaId, phoneNumberId, testPhoneNumber.value, testingMessageTemplate.value
    )
    const message = response.messages[0]
    toastSuccess(`Sent message to ${testPhoneNumber.value}. Message ID: ${message.id} (status: ${message.message_status})`)
  } catch (error) {
    toastError('Error testing message template')
  }
  loading.value = false
}

async function synchronizeMessageTemplates () {
  loading.value = true
  const metaService = await MetaService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  try {
    await metaService.synchronizeMessageTemplates(wabaId, phoneNumberId)
    toastSuccess('Message templates synchronized')
    await getMessageTemplates(wabaId, phoneNumberId)
  } catch (error) {
    toastError('Error synchronizing message templates')
  }
  loading.value = false
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getphoneNumber (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    phoneNumber.value = await accountService.getphoneNumber(wabaId, phoneNumberId)
  } catch {
    toastError('Error getting phone number')
  }
}

async function getMessageTemplates (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    messageTemplates.value = await accountService.getMessageTemplates(wabaId, phoneNumberId)
  } catch {
    toastError('Error getting message templates')
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  if (phoneNumberId && wabaId) {
    await getphoneNumber(wabaId, phoneNumberId)
    await getMessageTemplates(wabaId, phoneNumberId)
  } else {
    router.push({ name: 'home' })
  }

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && phoneNumber.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            eyebrow: "Phone number settings",
            title: "Message templates",
            description: "View, test, and manage the templates available for this phone number.",
            icon: "tabler:message-code",
            breadcrumbs: templateBreadcrumbs.value
          }, {
            actions: _withCtx(() => [
              _createVNode(_unref(AButton), {
                color: "blue",
                variant: "outlined",
                "prepend-icon": "tabler:refresh",
                onClick: synchronizeMessageTemplates
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode(" Synchronize ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["breadcrumbs"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                      _createElementVNode("h2", null, "Available templates"),
                      _createElementVNode("p", null, "Select a template to prepare a test message.")
                    ], -1)),
                    _createVNode(_unref(ATag), {
                      text: `${filteredMessageTemplates.value.length} ${filteredMessageTemplates.value.length === 1 ? 'template' : 'templates'}`,
                      color: "primary",
                      type: "secondary",
                      pill: ""
                    }, null, 8, ["text"])
                  ]),
                  _createVNode(_unref(AInput), {
                    modelValue: templateSearch.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateSearch).value = $event)),
                    class: "bsp-search-input",
                    label: "Search templates",
                    placeholder: "Name, language, or status",
                    "prepend-inner-icon": "tabler:search",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  (filteredMessageTemplates.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMessageTemplates.value, (messageTemplate) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["message-template", { 'selected': testingMessageTemplate.value && messageTemplate.name == testingMessageTemplate.value.name }]),
                            onClick: ($event: any) => (selectTestTemplate(messageTemplate)),
                            key: messageTemplate.id
                          }, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(messageTemplate.name), 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_unref(ATag), {
                                text: messageTemplate.language,
                                color: "info",
                                type: "secondary",
                                pill: ""
                              }, null, 8, ["text"]),
                              _createVNode(_unref(ATag), {
                                text: messageTemplate.status,
                                color: messageTemplate.status === 'APPROVED' ? 'success' : messageTemplate.status === 'REJECTED' ? 'error' : 'warning',
                                type: "secondary",
                                pill: ""
                              }, null, 8, ["text", "color"]),
                              (messageTemplate.rejected_reason !== 'NONE')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(messageTemplate.rejected_reason || ''), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_unref(AButton), {
                                color: "red",
                                variant: "text",
                                size: "small",
                                "prepend-icon": "tabler:trash",
                                onClick: _withModifiers(($event: any) => (deleteMessageTemplate(messageTemplate)), ["stop"])
                              }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode(" Delete ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ], 10, _hoisted_9))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                        key: 1,
                        title: "No templates found",
                        description: templateSearch.value ? 'Try another search.' : 'Synchronize with Meta to load the available templates.',
                        icon: "tabler:message-off"
                      }, null, 8, ["description"]))
                ]),
                (testingMessageTemplate.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                          _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Controlled message"),
                          _createElementVNode("h3", { id: "template-test-title" }, "Test template"),
                          _createElementVNode("p", null, "Complete the variables and review the message before sending it.")
                        ], -1)),
                        _createVNode(_unref(ATag), {
                          text: testingMessageTemplate.value.name,
                          color: "primary",
                          type: "secondary",
                          "prepend-icon": "tabler:message-code",
                          "limited-width": 240,
                          pill: ""
                        }, null, 8, ["text"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_unref(AIcon), {
                              icon: "tabler:message-circle",
                              color: "primary",
                              size: "18"
                            }),
                            _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Message preview"),
                              _createElementVNode("p", null, "This is how the main content will appear in WhatsApp.")
                            ], -1))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:brand-whatsapp",
                                color: "success",
                                size: "16"
                              }),
                              _cache[23] || (_cache[23] = _createElementVNode("span", null, "Template message", -1))
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testingMessageTemplate.value.components, (component, componentIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: componentIndex,
                                  class: "bsp-template-preview__component"
                                }, [
                                  (_unref(isWhatsappHeaderComponent)(component))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        (component.parameters?.length && _unref(isImageHeaderParameter)(component.parameters[0]))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: component.parameters[0].image.link,
                                                onError: _cache[1] || (_cache[1] = ($event: any) => (failedToLoadImage.value = true)),
                                                onLoad: _cache[2] || (_cache[2] = ($event: any) => (failedToLoadImage.value = false)),
                                                alt: "Header preview"
                                              }, null, 40, _hoisted_23), [
                                                [_vShow, !failedToLoadImage.value]
                                              ]),
                                              _withDirectives(_createElementVNode("div", _hoisted_24, [
                                                _createVNode(_unref(AIcon), {
                                                  icon: "tabler:photo-off",
                                                  color: "info",
                                                  size: "22"
                                                }),
                                                _cache[24] || (_cache[24] = _createElementVNode("span", null, "Unable to load the image", -1))
                                              ], 512), [
                                                [_vShow, failedToLoadImage.value]
                                              ])
                                            ], 64))
                                          : (component.format && component.format !== 'TEXT')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                _createVNode(_unref(AIcon), {
                                                  icon: "tabler:paperclip",
                                                  color: "info",
                                                  size: "22"
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(component.format.toLowerCase()) + " header", 1)
                                              ]))
                                            : (component.text)
                                              ? (_openBlock(), _createElementBlock("strong", _hoisted_26, _toDisplayString(component.text), 1))
                                              : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (component.type === 'body')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(component.text), 1))
                                    : _createCommentVNode("", true),
                                  (component.type === 'footer')
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(component.text), 1))
                                    : _createCommentVNode("", true),
                                  (component.type === 'button')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createVNode(_unref(AIcon), {
                                          icon: component.sub_type === 'phone_number' ? 'tabler:phone' : component.sub_type === 'url' ? 'tabler:external-link' : component.sub_type === 'copy_code' ? 'tabler:copy' : 'tabler:corner-up-left',
                                          color: "primary",
                                          size: "15"
                                        }, null, 8, ["icon"]),
                                        _createElementVNode("span", null, _toDisplayString(component.text || (component.sub_type === 'phone_number' ? 'Call' : component.sub_type === 'url' ? 'Open link' : component.sub_type === 'copy_code' ? 'Copy code' : 'Reply')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_unref(AIcon), {
                              icon: "tabler:braces",
                              color: "primary",
                              size: "18"
                            }),
                            _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Message variables"),
                              _createElementVNode("p", null, "The values you enter replace the template placeholders.")
                            ], -1))
                          ]),
                          (testTemplateParameterCount.value === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_unref(AIcon), {
                                  icon: "tabler:circle-check",
                                  color: "success",
                                  size: "18"
                                }),
                                _cache[26] || (_cache[26] = _createTextVNode(" This template doesn't require variables. ", -1))
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testingMessageTemplate.value.components, (component, componentIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `parameters-${componentIndex}`,
                              class: "bsp-template-variable-component"
                            }, [
                              (_unref(isWhatsappHeaderComponent)(component) && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _cache[30] || (_cache[30] = _createElementVNode("h5", null, "Header", -1)),
                                    (_unref(isTextHeaderParameter)(component.parameters[0]))
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((component.parameters as TextHeaderParameter[]), (parameter, parameterIndex) => {
                                          return (_openBlock(), _createBlock(_unref(AInput), {
                                            key: parameter.id || parameterIndex,
                                            modelValue: parameter.text,
                                            "onUpdate:modelValue": ($event: any) => ((parameter.text) = $event),
                                            size: "small",
                                            label: `Variable {{${parameterIndex + 1}}}`,
                                            placeholder: "Enter a value"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                        }), 128))
                                      : (_unref(isImageHeaderParameter)(component.parameters[0]))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                            _createVNode(_unref(AInput), {
                                              modelValue: component.parameters[0].image.link,
                                              "onUpdate:modelValue": ($event: any) => ((component.parameters[0].image.link) = $event),
                                              size: "small",
                                              label: "Image URL",
                                              placeholder: "https://..."
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            _createVNode(_unref(AButton), {
                                              variant: "text",
                                              size: "small",
                                              "prepend-icon": "tabler:restore",
                                              onClick: ($event: any) => (component.parameters[0].image.link = component.parameters[0].image.default || '')
                                            }, {
                                              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                _createTextVNode(" Restore original URL ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]))
                                        : (_unref(isVideoHeaderParameter)(component.parameters[0]))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createVNode(_unref(AInput), {
                                                modelValue: component.parameters[0].video.link,
                                                "onUpdate:modelValue": ($event: any) => ((component.parameters[0].video.link) = $event),
                                                size: "small",
                                                label: "Video URL",
                                                placeholder: "https://..."
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                              _createVNode(_unref(AButton), {
                                                variant: "text",
                                                size: "small",
                                                "prepend-icon": "tabler:restore",
                                                onClick: ($event: any) => (component.parameters[0].video.link = component.parameters[0].video.default || '')
                                              }, {
                                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                  _createTextVNode(" Restore original URL ", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]))
                                          : (_unref(isDocumentHeaderParameter)(component.parameters[0]))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                _createVNode(_unref(AInput), {
                                                  modelValue: component.parameters[0].document.link,
                                                  "onUpdate:modelValue": ($event: any) => ((component.parameters[0].document.link) = $event),
                                                  size: "small",
                                                  label: "Document URL",
                                                  placeholder: "https://..."
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_unref(AInput), {
                                                  modelValue: component.parameters[0].document.filename,
                                                  "onUpdate:modelValue": ($event: any) => ((component.parameters[0].document.filename) = $event),
                                                  size: "small",
                                                  label: "File name",
                                                  placeholder: "document.pdf"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_unref(AButton), {
                                                  variant: "text",
                                                  size: "small",
                                                  "prepend-icon": "tabler:restore",
                                                  onClick: ($event: any) => (component.parameters[0].document.link = component.parameters[0].document.default || '')
                                                }, {
                                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                    _createTextVNode(" Restore original URL ", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]))
                                            : (_unref(isLocationHeaderParameter)(component.parameters[0]))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.latitude,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.latitude) = $event),
                                                    size: "small",
                                                    label: "Latitude"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.longitude,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.longitude) = $event),
                                                    size: "small",
                                                    label: "Longitude"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.name,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.name) = $event),
                                                    size: "small",
                                                    label: "Name"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.address,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.address) = $event),
                                                    size: "small",
                                                    label: "Address"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]))
                                              : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (component.type === 'body' && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _cache[31] || (_cache[31] = _createElementVNode("h5", null, "Message body", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.parameters, (parameter, parameterIndex) => {
                                      return (_openBlock(), _createBlock(_unref(AInput), {
                                        key: parameterIndex,
                                        modelValue: parameter.text,
                                        "onUpdate:modelValue": ($event: any) => ((parameter.text) = $event),
                                        size: "small",
                                        label: `Variable {{${parameterIndex + 1}}}`,
                                        placeholder: "Enter a value"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (component.type === 'button' && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _cache[32] || (_cache[32] = _createElementVNode("h5", null, "Button action", -1)),
                                    (component.sub_type === 'quick_reply')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 0,
                                          modelValue: component.parameters[0].payload,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].payload) = $event),
                                          size: "small",
                                          label: "Reply payload",
                                          placeholder: "Payload"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'phone_number')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 1,
                                          modelValue: component.parameters[0].text,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].text) = $event),
                                          size: "small",
                                          label: "Phone number",
                                          placeholder: "569..."
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'url')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 2,
                                          modelValue: component.parameters[0].text,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].text) = $event),
                                          size: "small",
                                          label: "URL suffix",
                                          placeholder: "value"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'copy_code')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 3,
                                          modelValue: component.parameters[0].coupon_code,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].coupon_code) = $event),
                                          size: "small",
                                          label: "Code",
                                          placeholder: "Code"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:device-mobile-message",
                            color: "primary",
                            size: "22"
                          })
                        ]),
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "bsp-template-recipient__copy" }, [
                          _createElementVNode("h4", null, "Recipient phone number"),
                          _createElementVNode("p", null, "Use international format without spaces or the “+” symbol.")
                        ], -1)),
                        _createVNode(_unref(AInput), {
                          modelValue: testPhoneNumber.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((testPhoneNumber).value = $event)),
                          class: "bsp-template-recipient__input",
                          type: "tel",
                          size: "small",
                          label: "Test phone number",
                          placeholder: "56912345678",
                          "prepend-inner-icon": "tabler:phone"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(AButton), {
                          color: "blue",
                          "prepend-icon": "tabler:send",
                          disabled: !testPhoneNumber.value.trim(),
                          onClick: testMessageTemplate
                        }, {
                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createTextVNode(" Send test ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _cache[55] || (_cache[55] = _createElementVNode("div", { class: "bsp-section-heading" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, "New template"),
                  _createElementVNode("p", null, "Define the content you'll submit to Meta for review.")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_unref(AInput), {
                  modelValue: messageTemplateName.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((messageTemplateName).value = $event)),
                  label: "Name",
                  placeholder: "my_template"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ASelector), {
                  modelValue: messageTemplateLanguage.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((messageTemplateLanguage).value = $event)),
                  items: languageOptions,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Language",
                  placeholder: "Select a language"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ASelector), {
                  modelValue: messageTemplateCategory.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((messageTemplateCategory).value = $event)),
                  items: categoryOptions,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Category",
                  placeholder: "Select a category"
                }, null, 8, ["modelValue"]),
                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "bsp-form-label" }, "Components", -1)),
                _createElementVNode("div", _hoisted_44, [
                  (headerComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", _hoisted_48, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:layout-navbar",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[35] || (_cache[35] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Header"),
                              _createElementVNode("p", null, "Optional content that appears before the message.")
                            ], -1))
                          ]),
                          _createVNode(_unref(AButton), {
                            icon: "tabler:x",
                            variant: "text",
                            size: "small",
                            "help-text": "Remove header",
                            "aria-label": "Remove header",
                            onClick: removeHeaderComponent
                          })
                        ]),
                        _createVNode(_unref(ASelector), {
                          modelValue: headerComponent.value.format,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((headerComponent.value.format) = $event)),
                          items: headerFormatOptions,
                          "item-title": "title",
                          "item-value": "value",
                          label: "Format",
                          size: "small"
                        }, null, 8, ["modelValue"]),
                        (headerComponent.value.format === 'TEXT')
                          ? (_openBlock(), _createBlock(_unref(AInput), {
                              key: 0,
                              modelValue: headerComponent.value.text,
                              "onUpdate:modelValue": [
                                _cache[8] || (_cache[8] = ($event: any) => ((headerComponent.value.text) = $event)),
                                _cache[9] || (_cache[9] = ($event: any) => (headerComponent.value && onHeaderTextInput(headerComponent.value)))
                              ],
                              type: "textarea",
                              rows: 3,
                              size: "small",
                              label: "Header text",
                              placeholder: "Write the header"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (headerComponent.value.format === 'TEXT' && headerComponent.value.example)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "bsp-template-field-caption" }, "Variable examples", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerComponent.value.example.header_text, (parameter, parameterIndex) => {
                                return (_openBlock(), _createBlock(_unref(AInput), {
                                  key: parameterIndex,
                                  modelValue: headerComponent.value.example.header_text[parameterIndex],
                                  "onUpdate:modelValue": ($event: any) => ((headerComponent.value.example.header_text[parameterIndex]) = $event),
                                  size: "small",
                                  label: `Variable {{${parameterIndex + 1}}}`,
                                  placeholder: "Example value"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.value.format))
                          ? (_openBlock(), _createBlock(_unref(AInput), {
                              key: 2,
                              modelValue: headerComponent.value.text,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((headerComponent.value.text) = $event)),
                              type: "url",
                              size: "small",
                              label: "Sample file URL",
                              placeholder: "https://...",
                              "prepend-inner-icon": "tabler:link"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (headerComponent.value.format === 'LOCATION')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:map-pin",
                                color: "info",
                                size: "17"
                              }),
                              _cache[37] || (_cache[37] = _createTextVNode(" The location will be completed when preparing the message. ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (bodyComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("span", _hoisted_54, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:text-caption",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[38] || (_cache[38] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Body"),
                              _createElementVNode("p", null, "Main content the recipient will receive.")
                            ], -1))
                          ]),
                          _createVNode(_unref(AButton), {
                            icon: "tabler:x",
                            variant: "text",
                            size: "small",
                            "help-text": "Remove body",
                            "aria-label": "Remove body",
                            onClick: removeBodyComponent
                          })
                        ]),
                        _createVNode(_unref(AInput), {
                          modelValue: bodyComponent.value.text,
                          "onUpdate:modelValue": [
                            _cache[11] || (_cache[11] = ($event: any) => ((bodyComponent.value.text) = $event)),
                            _cache[12] || (_cache[12] = ($event: any) => (bodyComponent.value && onBodyTextInput(bodyComponent.value)))
                          ],
                          type: "textarea",
                          rows: 4,
                          size: "small",
                          label: "Message",
                          placeholder: "Write the template content"
                        }, null, 8, ["modelValue"]),
                        (bodyComponent.value.example)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "bsp-template-field-caption" }, "Variable examples", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyComponent.value.example.body_text[0], (parameter, parameterIndex) => {
                                return (_openBlock(), _createBlock(_unref(AInput), {
                                  key: parameterIndex,
                                  modelValue: bodyComponent.value.example.body_text[0][parameterIndex],
                                  "onUpdate:modelValue": ($event: any) => ((bodyComponent.value.example.body_text[0][parameterIndex]) = $event),
                                  size: "small",
                                  label: `Variable {{${parameterIndex + 1}}}`,
                                  placeholder: "Example value"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (buttonsComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("span", _hoisted_59, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:click",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[40] || (_cache[40] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Buttons"),
                              _createElementVNode("p", null, "Optional actions available below the message.")
                            ], -1))
                          ]),
                          _createVNode(_unref(AButton), {
                            icon: "tabler:x",
                            variant: "text",
                            size: "small",
                            "help-text": "Remove buttons",
                            "aria-label": "Remove buttons",
                            onClick: removeButtonsComponent
                          })
                        ]),
                        (buttonsComponent.value.buttons.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonsComponent.value.buttons, (button, buttonIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "bsp-template-button-editor",
                                  key: buttonIndex
                                }, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createVNode(_unref(ATag), {
                                      text: buttonTypeLabel(button.type),
                                      color: "info",
                                      type: "secondary",
                                      pill: ""
                                    }, null, 8, ["text"]),
                                    _createVNode(_unref(AButton), {
                                      icon: "tabler:trash",
                                      color: "red",
                                      variant: "text",
                                      size: "small",
                                      "help-text": "Delete button",
                                      "aria-label": "Delete button",
                                      onClick: ($event: any) => (removeTemplateButton(buttonIndex))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  (button.type === 'QUICK_REPLY')
                                    ? (_openBlock(), _createBlock(_unref(AInput), {
                                        key: 0,
                                        modelValue: button.text,
                                        "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                        size: "small",
                                        label: "Button text",
                                        placeholder: "E.g. View options"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true),
                                  (button.type === 'PHONE_NUMBER')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.text,
                                          "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                          size: "small",
                                          label: "Button text",
                                          placeholder: "E.g. Call"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.phone_number,
                                          "onUpdate:modelValue": ($event: any) => ((button.phone_number) = $event),
                                          type: "tel",
                                          size: "small",
                                          label: "Phone number",
                                          placeholder: "56912345678"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (button.type === 'URL')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.text,
                                          "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                          size: "small",
                                          label: "Button text",
                                          placeholder: "E.g. Open website"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.url,
                                          "onUpdate:modelValue": [($event: any) => ((button.url) = $event), ($event: any) => (onUrlButtonUrlInput(button))],
                                          type: "url",
                                          size: "small",
                                          label: "URL",
                                          placeholder: "https://..."
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(button.example, (parameter, parameterIndex) => {
                                          return (_openBlock(), _createBlock(_unref(AInput), {
                                            key: parameterIndex,
                                            modelValue: button.example[parameterIndex],
                                            "onUpdate:modelValue": ($event: any) => ((button.example[parameterIndex]) = $event),
                                            size: "small",
                                            label: `URL variable {{${parameterIndex + 1}}}`,
                                            placeholder: "Example value"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                        }), 128))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (button.type === 'COPY_CODE')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.text,
                                          "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                          size: "small",
                                          label: "Button text",
                                          placeholder: "Copy code"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_unref(AInput), {
                                          modelValue: button.example[0],
                                          "onUpdate:modelValue": ($event: any) => ((button.example[0]) = $event),
                                          size: "small",
                                          label: "Sample code",
                                          placeholder: "PROMO2026"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:info-circle",
                                color: "info",
                                size: "17"
                              }),
                              _cache[41] || (_cache[41] = _createTextVNode(" Add at least one button type using the options below. ", -1))
                            ])),
                        _createElementVNode("div", _hoisted_63, [
                          _createVNode(_unref(AButton), {
                            size: "small",
                            variant: "outlined",
                            "prepend-icon": "tabler:message-reply",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (addQuickReplyButton(buttonsComponent.value)))
                          }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("Quick reply", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(AButton), {
                            size: "small",
                            variant: "outlined",
                            "prepend-icon": "tabler:phone",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (addPhoneNumberButton(buttonsComponent.value)))
                          }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createTextVNode("Phone number", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(AButton), {
                            size: "small",
                            variant: "outlined",
                            "prepend-icon": "tabler:external-link",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (addUrlrButton(buttonsComponent.value)))
                          }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("URL", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(AButton), {
                            size: "small",
                            variant: "outlined",
                            "prepend-icon": "tabler:copy",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (addCopyCodeButton(buttonsComponent.value)))
                          }, {
                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                              _createTextVNode("Copy code", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (footerComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("span", _hoisted_67, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:layout-bottombar",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[46] || (_cache[46] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Footer"),
                              _createElementVNode("p", null, "Short supporting text at the end of the template.")
                            ], -1))
                          ]),
                          _createVNode(_unref(AButton), {
                            icon: "tabler:x",
                            variant: "text",
                            size: "small",
                            "help-text": "Remove footer",
                            "aria-label": "Remove footer",
                            onClick: removeFooterComponent
                          })
                        ]),
                        _createVNode(_unref(AInput), {
                          modelValue: footerComponent.value.text,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((footerComponent.value.text) = $event)),
                          type: "textarea",
                          rows: 2,
                          size: "small",
                          label: "Message footer",
                          placeholder: "E.g. Thank you for choosing us"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _cache[52] || (_cache[52] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "Add component"),
                    _createElementVNode("p", null, "You can remove it and add it again without losing the rest of the form.")
                  ], -1)),
                  _createElementVNode("div", _hoisted_69, [
                    (headerComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 0,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:layout-navbar",
                          onClick: addHeaderComponent
                        }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("Header", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (bodyComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 1,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:text-caption",
                          onClick: addBodyComponent
                        }, {
                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                            _createTextVNode("Body", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (footerComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 2,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:layout-bottombar",
                          onClick: addFooterComponent
                        }, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode("Footer", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (buttonsComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 3,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:click",
                          onClick: addButtonsComponent
                        }, {
                          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                            _createTextVNode("Buttons", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (headerComponent.value && bodyComponent.value && footerComponent.value && buttonsComponent.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:circle-check",
                            color: "success",
                            size: "16"
                          }),
                          _cache[51] || (_cache[51] = _createTextVNode(" All components have been added ", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(AButton), {
                  color: "blue",
                  block: "",
                  "prepend-icon": "tabler:send",
                  onClick: createMessageTemplate,
                  disabled: !validTemplate()
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode(" Create and submit for review ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
  ]))
}
}

})